export enum VisualizationType {
  ICON = 'IconVisualization',
  LINE = 'LineVisualization',
  POLYGON = 'PolygonVisualization',
  GENERIC = 'GenericVisualization',
  HEATMAP = 'HeatMapVisualization',
}
